import { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import SelectBox from "components/elements/selectBox";
import ReactImageMagnify from "react-image-magnify";
import { Link } from "react-router-dom";

function ModalInfomationProduct({ product }) {
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTranslation();
    const onClose = () => {
        setIsOpen(false);
    };
    useEffect(() => {
        if (product?._id) {
            setIsOpen(true)
        }
    }, [product]);

    return (
        <Fragment>
            {product?._id && product?.main_images &&
                <Modal
                    centered={true}
                    size="lg"
                    toggle={() => {
                        onClose();
                    }}
                    isOpen={isOpen}
                >
                    {/* <div className="modal-header">
                        <h3>Infomation Product</h3>
                        <div className="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                            <i
                                className="ki-outline ki-cross fs-1"
                                onClick={() => {
                                    onClose();
                                }}
                            ></i>
                        </div>
                    </div> */}
                    <ModalBody>
                        <h2 className="mb-5">
                            {product.title}
                        </h2>
                        <div className="mb-5">ID: {product.apiProductId}</div>
                        <div>
                            {product?.main_images.map((link, key) => (
                                <div className="al-thumb" key={key}>
                                    <div className="al-thumbInner position-relative">
                                        <Link to={link || require("components/assets/media/misc/image.png")} target="_blank">
                                            <div className="symbol symbol-100px">
                                                <ReactImageMagnify
                                                    {...{
                                                        smallImage: {
                                                            alt: "",
                                                            width: 100,
                                                            height: 100,
                                                            src: link || require("components/assets/media/misc/image.png"),
                                                        },
                                                        largeImage: {
                                                            src: link || require("components/assets/media/misc/image.png"),
                                                            width: 600,
                                                            height: 600,
                                                        },
                                                        enlargedImageContainerDimensions: { width: "600%", height: "600%" },
                                                        enlargedImageContainerStyle: { zIndex: 999999 },
                                                        className: "cursor-pointer al-product-img al-cursor-move w-100 h-100",
                                                        enlargedImageContainerClassName: "al-zoom-img-cus",
                                                        imageStyle: { zIndex: 9999999 },
                                                    }}
                                                />
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <button
                            type="reset"
                            id="kt_modal_users_search_reset"
                            data-bs-dismiss="modal"
                            className="btn btn-active-light me-3"
                            onClick={() => {
                                onClose();
                            }}
                        >
                            {t("Cancel")}
                        </button>
                    </ModalFooter>
                </Modal>}
        </Fragment>
    );
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ModalInfomationProduct);